(function () {
  'use strict';

  var NOTIFY_ME_SUBSCRIPTION_ENDPOINT = 'https://api.notify-me.app/subscription/';
  var NOTIFY_ME_DEFAULT_SHOP_ID = 6937;
  var thirdPartyWidgetObserver = null;
  var thirdPartyHideScheduled = false;

  function init() {
    initProductRestockForms(document);
    initThirdPartyWidgetHider();
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('change', handleDocumentChange);
    document.addEventListener('input', handleDocumentInput);
    document.addEventListener('submit', handleDocumentSubmit);
    document.addEventListener('dubia:product-restock:update', function (event) {
      var sectionId = event && event.detail && event.detail.sectionId;
      var root = sectionId ? document.getElementById('ProductRestock-' + sectionId) : document;
      initProductRestockForms(root || document);
      reopenProductRestockForms(root || document);
      hideThirdPartyProductRestockWidgets();
    });
  }

  function reopenProductRestockForms(root) {
    var wrappers = [];

    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('.product-detail-restock-wrapper[data-restock-opened]')) wrappers.push(root);
    root.querySelectorAll('.product-detail-restock-wrapper[data-restock-opened]').forEach(function (wrapper) {
      wrappers.push(wrapper);
    });

    wrappers.forEach(function (wrapper) {
      var openButton = wrapper.querySelector('[data-dubia-product-restock-open]');
      if (openButton) openProductRestockForm(openButton, false);
    });
  }

  function initProductRestockForms(root) {
    if (!root || !root.querySelectorAll) return;

    syncProductRestockFormState(root);

    root.querySelectorAll('[data-dubia-product-restock-form]').forEach(function (form) {
      prefillProductRestockForm(form);
      updateProductRestockChannel(form, getProductRestockChannel(form));
    });
  }

  function syncProductRestockFormState(root) {
    var wrappers = [];

    if (root.matches && root.matches('.product-detail-restock-wrapper')) wrappers.push(root);
    root.querySelectorAll('.product-detail-restock-wrapper').forEach(function (wrapper) {
      wrappers.push(wrapper);
    });

    wrappers.forEach(function (wrapper) {
      var form = wrapper.closest('form');
      var hasRestock = wrapper.classList.contains('has-restock') && Boolean(wrapper.querySelector('[data-dubia-product-restock]'));

      if (form) form.classList.toggle('has-product-detail-restock', hasRestock);
    });
  }

  function initThirdPartyWidgetHider() {
    hideThirdPartyProductRestockWidgets();

    if (thirdPartyWidgetObserver || !window.MutationObserver || !document.body) return;

    thirdPartyWidgetObserver = new MutationObserver(scheduleThirdPartyWidgetHide);
    thirdPartyWidgetObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function scheduleThirdPartyWidgetHide() {
    if (thirdPartyHideScheduled) return;

    thirdPartyHideScheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      thirdPartyHideScheduled = false;
      hideThirdPartyProductRestockWidgets();
    });
  }

  var THEME_OWNED_SELECTOR = '.product-card-drawer-shell';

  function isThemeOwned(element) {
    if (!element) return false;
    if (element.closest && element.closest(THEME_OWNED_SELECTOR)) return true;
    return Boolean(element.querySelector && element.querySelector(THEME_OWNED_SELECTOR));
  }

  function hideThirdPartyProductRestockWidgets() {
    var hasNativeRestock = Boolean(document.querySelector('[data-dubia-product-restock]'));
    var selectors = [
      '.product__info-container .nm-portal',
      '.product__info-container [id^="ps-bis-widget"]',
      '.product__info-container [class*="bestpush-bis"]',
      '.product__info-container [class*="ps-bis-widget"]',
      '#ps-mobile-widget-partial__container',
      '#ps-bis-widget-mobile-modal__container',
      'body > [id*="ps"][id*="bis"]',
      'body > [class*="ps-bis"]',
      'body > [id*="bestpush"]',
      'body > [class*="bestpush"]',
      'body > [id*="restock"]',
      'body > [class*="restock"]'
    ].join(', ');

    if (!hasNativeRestock) return;

    document.querySelectorAll(selectors).forEach(function (element) {
      if (element.closest('[data-dubia-product-restock]')) return;
      if (isThemeOwned(element)) return;
      if (containsProductPurchaseControls(element)) return;
      element.setAttribute('data-dubia-hidden-restock-widget', 'true');
      element.style.setProperty('display', 'none', 'important');
    });

    document.querySelectorAll('button, a, [role="button"], div').forEach(function (element) {
      var text = normalizeWhitespace(element.textContent).toLowerCase();
      var root;

      if (!text || element.closest('[data-dubia-product-restock]')) return;
      if (element.querySelector && element.querySelector('[data-dubia-product-restock]')) return;
      if (!/back in stock|notify me when|when available/.test(text)) return;
      if (!/(text|email|notify)/.test(text)) return;

      root = getThirdPartyWidgetRoot(element);
      if (root.querySelector && root.querySelector('[data-dubia-product-restock]')) return;
      if (isThemeOwned(element) || isThemeOwned(root)) return;
      if (containsProductPurchaseControls(root)) return;
      if (!isThirdPartyRestockWidgetCandidate(element, root)) return;

      root.setAttribute('data-dubia-hidden-restock-widget', 'true');
      root.style.setProperty('display', 'none', 'important');
    });
  }

  function containsProductPurchaseControls(element) {
    return element.matches('[name="add"]') || Boolean(element.querySelector('[name="add"]'));
  }

  function getThirdPartyWidgetRoot(element) {
    var current = element;
    var root = element;

    if (element.closest && element.closest('.product__info-container')) return element;

    while (current.parentElement && current.parentElement !== document.body) {
      if (isThirdPartyWidgetBoundary(current.parentElement)) return root;

      current = current.parentElement;
      root = current;
    }

    return root || element;
  }

  function isThirdPartyWidgetBoundary(element) {
    if (!element || !element.matches) return false;

    return element.matches([
      '#MainContent',
      'main',
      '.content-for-layout',
      '.shopify-section',
      '.product-detail-section',
      '.product',
      '.page-width',
      '.grid'
    ].join(', '));
  }

  function isThirdPartyRestockWidgetCandidate(element, root) {
    var metadata;

    if (element.closest && element.closest('.product__info-container')) return true;

    metadata = [
      element.id,
      element.className,
      root && root.id,
      root && root.className
    ].map(function (value) {
      return String(value || '');
    }).join(' ').toLowerCase();

    return /restock|back[-_\s]*in[-_\s]*stock|notify|bis|nm-portal|bestpush|ps-bis/.test(metadata);
  }

  function handleDocumentClick(event) {
    var openButton = event.target && event.target.closest && event.target.closest('[data-dubia-product-restock-open]');
    var submitButton = event.target && event.target.closest && event.target.closest('[data-dubia-product-restock-submit]');
    var channelOption = event.target && event.target.closest && event.target.closest('.product-detail-restock__channel-option');
    var channelInput;

    if (openButton) {
      event.preventDefault();
      openProductRestockForm(openButton);
      return;
    }

    if (submitButton) {
      event.preventDefault();
      submitProductRestockForm(submitButton.closest('[data-dubia-product-restock-form]'));
      return;
    }

    if (!channelOption) return;

    channelInput = channelOption.querySelector('[data-dubia-product-restock-channel]');
    if (!channelInput || channelInput.disabled) return;

    channelInput.checked = true;
    updateProductRestockChannel(channelInput.closest('[data-dubia-product-restock-form]'), channelInput.value);
  }

  function openProductRestockForm(openButton, moveFocus) {
    var form = document.getElementById(openButton.getAttribute('aria-controls'));
    var wrapper = openButton.closest('.product-detail-restock-wrapper');
    var channelInput;
    var input;

    if (!form) return;

    if (wrapper) wrapper.setAttribute('data-restock-opened', '');
    form.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    openButton.hidden = true;
    channelInput = form.querySelector('[data-dubia-product-restock-channel]:checked');
    if (channelInput) updateProductRestockChannel(form, channelInput.value);
    input = form.querySelector('.product-detail-restock__field:not([hidden]) input');
    if (input && moveFocus !== false) input.focus();
  }

  function handleDocumentChange(event) {
    var channelInput = event.target && event.target.closest && event.target.closest('[data-dubia-product-restock-channel]');

    if (!channelInput) return;

    updateProductRestockChannel(channelInput.closest('[data-dubia-product-restock-form]'), channelInput.value);
  }

  function handleDocumentInput(event) {
    if (!event.target || !event.target.matches('[data-dubia-product-restock-email], [data-dubia-product-restock-phone]')) return;

    clearProductRestockStatus(event.target.closest('[data-dubia-product-restock-form]'));
  }

  function handleDocumentSubmit(event) {
    var form = event.target && event.target.closest && event.target.closest('[data-dubia-product-restock-form]');

    if (!form) return;

    event.preventDefault();
    submitProductRestockForm(form);
  }

  function submitProductRestockForm(form) {
    var restock = form && form.closest('[data-dubia-product-restock]');
    var emailInput = form && form.querySelector('[data-dubia-product-restock-email]');
    var phoneInput = form && form.querySelector('[data-dubia-product-restock-phone]');
    var channel = getProductRestockChannel(form);
    var email = normalizeWhitespace(emailInput && emailInput.value);
    var phone = normalizeWhitespace(phoneInput && phoneInput.value);
    var contact;

    if (!restock || !restock.getAttribute('data-variant-id')) {
      setProductRestockStatus(form, 'error', 'Choose an available option for alerts.');
      return;
    }

    if (channel === 'email' && !isValidRestockEmail(email)) {
      setProductRestockStatus(form, 'error', 'Enter a valid email address.');
      if (emailInput && typeof emailInput.focus === 'function') emailInput.focus();
      return;
    }

    if (channel === 'text' && !isValidRestockPhone(phone)) {
      setProductRestockStatus(form, 'error', 'Enter a valid US mobile number.');
      if (phoneInput && typeof phoneInput.focus === 'function') phoneInput.focus();
      return;
    }

    contact = {
      channel: channel,
      email: channel === 'email' ? email : null,
      phoneNumber: channel === 'text' ? formatRestockPhoneNumber(phone) : null
    };

    setProductRestockSubmitting(form, true);
    clearProductRestockStatus(form);

    fetchWithTimeout(NOTIFY_ME_SUBSCRIPTION_ENDPOINT, getNotifyMeSubscriptionRequest(restock, contact), 9000)
      .then(function (response) {
        if (response.ok) return { message: channel === 'text' ? 'You are on the list. We will text you when this option is available.' : 'You are on the list. We will email you when this option is available.' };
        if (response.status === 409) return { message: 'You are already on the list for this option.' };
        if (response.status === 429) throw new Error('Too many attempts. Please try again later.');

        return response.json().catch(function () {
          return null;
        }).then(function (data) {
          throw new Error(getNotifyMeApiErrorMessage(data) || 'Notify signup is unavailable right now. Please try again in a moment.');
        });
      })
      .then(function (result) {
        persistRestockContact(contact);
        setProductRestockStatus(form, 'success', result.message);
      })
      .catch(function (error) {
        var message = error && error.name === 'AbortError'
          ? 'Notify signup timed out. Please try again.'
          : error && error.message
            ? error.message
            : 'Notify signup is unavailable right now. Please try again in a moment.';

        setProductRestockStatus(form, 'error', message);
      })
      .finally(function () {
        setProductRestockSubmitting(form, false);
      });
  }

  function getProductRestockChannel(form) {
    var checkedChannel = form && form.querySelector('[data-dubia-product-restock-channel]:checked');
    var channel = checkedChannel ? checkedChannel.value : form && form.getAttribute('data-restock-channel');

    return channel === 'text' ? 'text' : 'email';
  }

  function updateProductRestockChannel(form, channel) {
    var emailInput = form && form.querySelector('[data-dubia-product-restock-email]');
    var phoneInput = form && form.querySelector('[data-dubia-product-restock-phone]');
    var emailField = emailInput && emailInput.closest('.product-detail-restock__field');
    var phoneField = phoneInput && phoneInput.closest('.product-detail-restock__field');
    var button = form && form.querySelector('[data-dubia-product-restock-submit]');

    if (!form) return;

    channel = channel === 'text' ? 'text' : 'email';
    form.setAttribute('data-restock-channel', channel);
    clearProductRestockStatus(form);

    if (emailInput) emailInput.required = channel === 'email';
    if (phoneInput) phoneInput.required = channel === 'text';
    if (emailField) emailField.hidden = channel !== 'email';
    if (phoneField) phoneField.hidden = channel !== 'text';

    if (button) {
      button.dataset.defaultText = channel === 'text' ? 'Text me when available' : 'Email me when available';
      if (!form.classList.contains('is-submitting')) button.textContent = button.dataset.defaultText;
    }
  }

  function prefillProductRestockForm(form) {
    var emailInput = form && form.querySelector('[data-dubia-product-restock-email]');
    var phoneInput = form && form.querySelector('[data-dubia-product-restock-phone]');
    var email = getAutofillEmail();
    var phone = getAutofillPhone();

    if (emailInput && !emailInput.value && email) emailInput.value = email;
    if (phoneInput && !phoneInput.value && phone) phoneInput.value = formatRestockPhoneInput(phone);
  }

  function getNotifyMeSubscriptionRequest(restock, contact) {
    return {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(getNotifyMeSubscriptionPayload(restock, contact))
    };
  }

  function getNotifyMeSubscriptionPayload(restock, contact) {
    var productId = restock.getAttribute('data-product-id');
    var variantId = cleanVariantId(restock.getAttribute('data-variant-id'));

    return {
      full_name: null,
      email: contact && contact.email ? contact.email : null,
      phone_number: contact && contact.phoneNumber ? contact.phoneNumber : null,
      whatsapp_number: null,
      push_token: null,
      push_provider: null,
      locale: getShopifyLocale(),
      product_id: normalizeNumericPayloadId(productId),
      quantity: 1,
      url: getProductRestockUrl(restock, variantId),
      variant_id: normalizeNumericPayloadId(variantId),
      timezone: getNotifyMeTimezoneOffset(),
      contact_list_consent: false,
      shop_id: getNotifyMeShopId(),
      market_id: getNotifyMeMarketId()
    };
  }

  function getProductRestockUrl(restock, variantId) {
    var productUrl = restock.getAttribute('data-product-url') || window.location.href;
    var handle = restock.getAttribute('data-product-handle');
    var url;

    try {
      url = new URL(productUrl, window.location.origin);
      if (handle && url.pathname.indexOf('/products/') === -1) {
        url.pathname = '/products/' + handle;
      }
      url.hash = '';
      if (variantId) url.searchParams.set('variant', variantId);
      return url.toString();
    } catch (error) {
      return productUrl;
    }
  }

  function fetchWithTimeout(url, options, timeout) {
    var controller;
    var timer;

    if (!window.AbortController) return fetch(url, options);

    controller = new AbortController();
    timer = window.setTimeout(function () {
      controller.abort();
    }, timeout);

    return fetch(url, Object.assign({}, options, { signal: controller.signal })).finally(function () {
      window.clearTimeout(timer);
    });
  }

  function normalizeNumericPayloadId(value) {
    var number = Number(value);

    return Number.isFinite(number) && String(value).match(/^\d+$/) ? number : value;
  }

  function cleanVariantId(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function getNotifyMeTimezoneOffset() {
    var offset = (new Date().getTimezoneOffset() / 60) * -1;

    if (!offset) return '0';
    return (offset > 0 ? '+' : '-') + Math.abs(offset);
  }

  function getShopifyLocale() {
    if (window.Shopify && Shopify.locale) return Shopify.locale;
    if (document.documentElement && document.documentElement.lang) return document.documentElement.lang;
    return 'en';
  }

  function getNotifyMeShopId() {
    var configShopId = window._ReStockConfig && window._ReStockConfig.shop_id;
    var shopId = Number(configShopId || NOTIFY_ME_DEFAULT_SHOP_ID);

    return Number.isFinite(shopId) ? shopId : NOTIFY_ME_DEFAULT_SHOP_ID;
  }

  function getNotifyMeMarketId() {
    if (window._ReStockConfig && window._ReStockConfig.marketId) return window._ReStockConfig.marketId;
    if (window.Shopify && Shopify.market && Shopify.market.id) return Shopify.market.id;
    return null;
  }

  function getNotifyMeApiErrorMessage(data) {
    if (!data || typeof data !== 'object') return '';

    return data.message || data.detail || data.error || '';
  }

  function isValidRestockEmail(email) {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/.test(String(email || '').toLowerCase());
  }

  function isValidRestockPhone(phone) {
    return Boolean(normalizeRestockPhoneDigits(phone));
  }

  function normalizeRestockPhoneDigits(phone) {
    var digits = String(phone || '').replace(/\D/g, '');

    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    return digits.length === 10 ? digits : '';
  }

  function formatRestockPhoneNumber(phone) {
    var digits = normalizeRestockPhoneDigits(phone);

    return digits ? '+1' + digits : null;
  }

  function formatRestockPhoneInput(phone) {
    var digits = normalizeRestockPhoneDigits(phone);

    if (!digits) return normalizeWhitespace(phone);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  function getAutofillEmail() {
    var contact = window.DubiaCustomerContact || {};
    var storedEmail = '';

    try {
      storedEmail = window.localStorage.getItem('clientEmail') || '';
    } catch (error) {}

    return normalizeWhitespace(contact.email || storedEmail);
  }

  function getAutofillPhone() {
    var contact = window.DubiaCustomerContact || {};
    var storedPhone = '';

    try {
      storedPhone = window.localStorage.getItem('clientNumber') || '';
    } catch (error) {}

    return normalizeWhitespace(contact.phone || storedPhone);
  }

  function persistRestockContact(contact) {
    try {
      if (contact && contact.email) window.localStorage.setItem('clientEmail', contact.email);
      if (contact && contact.phoneNumber) {
        window.localStorage.setItem('clientNumber', normalizeRestockPhoneDigits(contact.phoneNumber));
        window.localStorage.setItem('clientCountryCode', 'US');
        window.localStorage.setItem('clientCountryPreNumber', '+1');
      }
    } catch (error) {}
  }

  function setProductRestockSubmitting(form, isSubmitting) {
    var inputs = form ? Array.from(form.querySelectorAll('[data-dubia-product-restock-email], [data-dubia-product-restock-phone], [data-dubia-product-restock-channel]')) : [];
    var button = form && form.querySelector('[data-dubia-product-restock-submit]');

    if (!form) return;

    form.classList.toggle('is-submitting', Boolean(isSubmitting));

    inputs.forEach(function (input) {
      input.disabled = Boolean(isSubmitting);
    });

    if (button) {
      if (!button.dataset.defaultText) button.dataset.defaultText = button.textContent;
      button.disabled = Boolean(isSubmitting);
      button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      button.textContent = isSubmitting ? 'Submitting...' : button.dataset.defaultText;
    }
  }

  function setProductRestockStatus(form, type, message) {
    var status = form && form.querySelector('[data-dubia-product-restock-status]');

    if (!status) return;

    status.classList.remove('is-success', 'is-error');
    if (type) status.classList.add('is-' + type);
    status.textContent = message || '';
  }

  function clearProductRestockStatus(form) {
    setProductRestockStatus(form, '', '');
  }

  function normalizeWhitespace(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
